import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Label, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { H2, H3 } from "../../../../AbstractElements";
import webservice from "../../../../Service/webservice";
import websocket_webservice from "../../../../Service/websocket_webservice";
import { AesDecrypt, AesEncrypt, keyPromise } from "../../../../Service/crypto";
import { ApexOptions } from 'apexcharts';
import { Controller, useForm } from "react-hook-form";
import Select, { SingleValue } from "react-select";
import classnames from "classnames";
import { getfilestatuscounts } from '../store/index';
import { useDispatch } from "react-redux";
import Chart from "react-google-charts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import api from '../../../../api';

interface CompanyOption {
    label: string;
    value: string;
}

interface IClientOption {
    label: string;
    value: string;
}

// Counted on the server (api/Dashboard/getfilestatuscounts).
interface FileStatusCounts {
    received: number;
    completed: number;
    yet_to_start: number;
    in_progress: number;
    error: number;
    regenerated: number;
    downloaded: number;
}

const EMPTY_COUNTS: FileStatusCounts = {
    received: 0, completed: 0, yet_to_start: 0, in_progress: 0, error: 0, regenerated: 0, downloaded: 0,
};

const OrderStatus = () => {
    const { control } = useForm();
    const dispatch = useDispatch();
    const [selectedClient, setSelectedClient] = useState<string>('All');
    const [selectedClientId, setSelectedClientId] = useState<string>('ALL');
    const [clientOptions, setClientOptions] = useState<IClientOption[]>([]);
    const [counts, setCounts] = useState<FileStatusCounts>(EMPTY_COUNTS);
    const [loading, setLoading] = useState<boolean>(false);
    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(new Date());

    const UserType = localStorage.UserType;
    const Id = localStorage.VendorId;

    const get_companyname = async () => {
        let bodyData = {};
        const token = localStorage.getItem("token");
        if (UserType === 'MOS') {
            bodyData = { UserType };
        } else if (UserType === 'Vendor') {
            bodyData = { UserType, VendorId: Id };
        }

        const response = await api.fetch('api/Dashboard/getclient', {
            method: 'POST',
            body: JSON.stringify(bodyData),
        }).then((response) => response.json());
        const key = await keyPromise
        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchRoleId = async () => {
            try {
                const response = await get_companyname();
                const companyData = response.map((data: any) => ({
                    label: data.CompanyName,
                    value: data.id,
                }));

                const sortedCompanyData = companyData.slice().sort((a: CompanyOption, b: CompanyOption) => a.label.localeCompare(b.label));
                const allOption = { label: 'All', value: 'ALL' };
                const companyDataWithAll = [allOption, ...sortedCompanyData];

                setClientOptions(companyDataWithAll);

            } catch (error) {
                console.error(error);
            }
        };

        fetchRoleId();
        const socket = new WebSocket(`${websocket_webservice}ws/ClientDropdown/`);

        socket.onmessage = () => {
            fetchRoleId();
        };

        return () => {
            if (socket.readyState === 1) {
                socket.close();
            }
        }
    }, []);

    const handleSelectClientChange = (selectedOption: SingleValue<IClientOption>) => {
        if (selectedOption) {
            if (localStorage.Usertype === 'Vendor' && selectedOption.value === 'ALL') {
                const allClient: any = clientOptions.filter(option => option.value !== 'ALL').map((option) => option.value);
                setSelectedClientId(allClient)
            } else {

                setSelectedClientId(selectedOption.value);
            }
            setSelectedClient(selectedOption.label);
            // template()
        } else {
            setSelectedClientId('ALL');
            setSelectedClient('');

        }
    }

    const ViewAuditLog = async () => {
        const Username = localStorage.UserName;
        const Userid = localStorage.id;
        const Clientname = selectedClient;
        const Chartname = 'File Status'
        const Data = { Username, Clientname, Userid, Chartname };
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, Data);
        const response = await api.fetch('api/Dashboard/auditlog', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());
        return response;
    };

    useEffect(() => {
        let clientid: string | null;
        if (localStorage.UserType === 'MOS') {
            clientid = selectedClientId;
        } else if (localStorage.UserType === 'Vendor') {
            if (selectedClientId === 'ALL') {
                const allClient: any = clientOptions.filter(option => option.value !== 'ALL').map((option) => option.value);
                clientid = allClient;
            } else {
                clientid = selectedClientId;
            }
        } else {
            clientid = localStorage.ClientId;
        }

        const formattedStartDate = startDate ? format(startDate, "yyyy-MM-dd") : null; // Format date
        const formattedEndDate = endDate ? format(endDate, "yyyy-MM-dd") : null; // Format date
        const data = { clientid, formattedStartDate, formattedEndDate, UserType: localStorage.UserType };

        // A slower, older request must not overwrite the result of a newer one
        // (changing client/dates quickly used to show whichever answer arrived last).
        let stale = false;

        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await dispatch<any>(getfilestatuscounts(data));
                if (stale) return;
                const payload = res.payload as Partial<FileStatusCounts> | undefined;
                if (!payload || typeof payload.received !== "number") {
                    console.error("Error fetching file status counts:", res.error || payload);
                    setCounts(EMPTY_COUNTS);
                    return;
                }
                setCounts({ ...EMPTY_COUNTS, ...payload });
            } catch (error) {
                if (!stale) console.error("Error fetching data:", error);
            } finally {
                if (!stale) setLoading(false);
            }
        };
        if (clientOptions.length !== 0) {

            fetchData();
        }
        // const socket = new WebSocket(`${websocket_webservice}ws/Dashboardpatient/`);

        // socket.onmessage = () => {
        //     fetchData();
        // };

        // return () => {
        //     if (socket.readyState === 1) {
        //         socket.close();
        //     }
        // }
        return () => {
            stale = true;
        };
    }, [dispatch, selectedClientId, selectedClient, startDate, endDate, clientOptions]);


    useEffect(() => {
        ViewAuditLog();
    }, []);

    const columnColors = {
        yet_to_start: '#ff8430',
        inprogress: '#ffff00',
        completed: '#009933',
        download: '#9966ff',
        apierror: '#ff0000',
        regenerated: '#990099',
    };

    const allCountsZero =
        counts.in_progress === 0 &&
        counts.completed === 0 &&
        counts.yet_to_start === 0 &&
        counts.downloaded === 0 &&
        counts.error === 0 &&
        counts.regenerated === 0;

    const googleChartDatas = {
        GooglePieChart1: {
            width: "100%",
            height: "400px",
            chartType: "PieChart",
            data: allCountsZero
                ? [
                    ["Task", "Count"],
                    ["No Data", 1],
                ]
                : [
                    ["Task", "Count"],
                    ["Yet to Start", counts.yet_to_start],
                    ["In Progress", counts.in_progress],
                    ["Completed", counts.completed],
                    ["Downloaded", counts.downloaded],
                    ["Error", counts.error],
                    ["Regenerated", counts.regenerated],
                ],
            option: {
                colors: allCountsZero
                    ? ["#ccc"]
                    : [
                        columnColors.yet_to_start,
                        columnColors.inprogress,
                        columnColors.completed,
                        columnColors.download,
                        columnColors.apierror,
                        columnColors.regenerated,
                    ],
                is3D: true,
                pieSliceTextStyle: {
                    color: 'white',
                },
                slices: {
                    0: { textStyle: { color: 'black' } }, // Yet to Start (orange) - black text
                    1: { textStyle: { color: 'black' } }, // In Progress (yellow) - black text
                    2: { textStyle: { color: 'white' } }, // Completed (green) - white text
                    3: { textStyle: { color: 'white' } }, // Downloaded (purple) - white text
                    4: { textStyle: { color: 'white' } }, // API Error (red) - white text
                    5: { textStyle: { color: 'white' } }, // Regenerated (dark purple) - white text
                },
            },
            rootProps: {
                "data-testid": "1",
            },
        },
    };

    return (
        <Card>
            {/* Title at the Top */}
            <div style={{ padding: "1rem" }}>
                <H3 className="m-0">Over All File Status</H3>
            </div>
            <CardHeader>
                <div className="header-top">
                    <Col xl={12}>
                        {(localStorage.UserType === 'MOS' || localStorage.UserType === 'Vendor') && (
                            <div style={{ display: 'flex', alignItems: "center", gap: "20px", width: "100%" }}>
                                {/* Select Client */}
                                <div style={{ flex: 1 }}>
                                    <Label className="form-label" style={{ fontSize: "100%", display: "block" }}>
                                        Select Client
                                    </Label>
                                    <Controller
                                        name="client"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                isClearable
                                                options={clientOptions}
                                                classNamePrefix="select"
                                                placeholder="Client Names"
                                                className={classnames("form-control")}
                                                styles={{
                                                    control: (styles) => ({
                                                        ...styles,
                                                        width: "100%",
                                                        height: '100%',
                                                        borderColor: "black",
                                                    }),
                                                    placeholder: (styles) => ({
                                                        ...styles,
                                                        textAlign: "center",
                                                    }),
                                                }}
                                                value={selectedClient ? { value: selectedClientId, label: selectedClient } : null}
                                                onChange={(selectedOption) => {
                                                    handleSelectClientChange(selectedOption as SingleValue<IClientOption>);
                                                    field.onChange(selectedOption);
                                                }}
                                            />
                                        )}
                                    />
                                </div>

                                {/* Select Date */}
                                <div style={{ flex: 1 }}>
                                    <Label className="form-label" style={{ fontSize: "100%", display: "block" }}>
                                        Start Date
                                    </Label>
                                    <div style={{ width: '100%' }}>
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(date) => setStartDate(date)}
                                            dateFormat="MM-dd-yyyy"
                                            className="form-control"
                                            maxDate={endDate || new Date()}
                                            selectsStart
                                            startDate={startDate}
                                            endDate={endDate}
                                        />
                                    </div>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Label className="form-label" style={{ fontSize: "100%", display: "block" }}>
                                        End Date
                                    </Label>
                                    <div style={{ width: '100%' }}>
                                        <DatePicker
                                            selected={endDate}
                                            onChange={(date) => setEndDate(date)}
                                            dateFormat="MM-dd-yyyy"
                                            className="form-control"
                                            minDate={startDate}
                                            maxDate={new Date()}
                                            selectsEnd
                                            startDate={startDate}
                                            endDate={endDate}
                                        />
                                    </div>
                                </div>
                            </div>

                        )}
                    </Col>
                </div>

                <Row style={{ textAlign: "center", marginTop: "1rem", marginBottom: "1rem" }}>
                    <H3>
                        Total File Count:
                        {loading ? " loading…" : counts.received}
                    </H3>
                </Row>
            </CardHeader>

            <CardBody>
                <div className="chart-overflow" id="pie-chart1" style={{ opacity: loading ? 0.4 : 1, transition: "opacity 0.2s" }}>
                    <Chart
                        width={googleChartDatas.GooglePieChart1.width}
                        height={googleChartDatas.GooglePieChart1.height}
                        chartType={"PieChart"}
                        loader={<div>{"Loading Chart"}</div>}
                        data={googleChartDatas.GooglePieChart1.data}
                        options={googleChartDatas.GooglePieChart1.option}
                        rootProps={googleChartDatas.GooglePieChart1.rootProps}
                    />
                </div>
            </CardBody>
        </Card>

    );
};

export default OrderStatus;
